import { Tooltip } from 'tamagui'

export default function OptionalTooltip({ title, show, children }) {
    return show ? (
        <Tooltip>
            <Tooltip.Trigger>{children}</Tooltip.Trigger>
            <Tooltip.Content>
                <Tooltip.Arrow />
                {title}
            </Tooltip.Content>
        </Tooltip>
    ) : children
}
